import {
  GET_PARTNER_HOST_DETAILS_LOADING,
  GET_PARTNER_HOST_DETAILS_SUCCESS,
  GET_PARTNER_HOST_DETAILS_FAILED,
} from "../types";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

type Action = {
  type: string;
  loading?: boolean;
  payload?: any;
  error?: any;
};

const getPartnerHostDetailsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case GET_PARTNER_HOST_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_PARTNER_HOST_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case GET_PARTNER_HOST_DETAILS_FAILED:
      return {
        ...state,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};

export default getPartnerHostDetailsReducer;
